<template>
  <div class="about__slider slider">
    <div class="slider__container" ref="slider">
      <div class="slider__wrapper">
        <a :href="slide.url" class="slider__slide" v-for="(slide, s) in slides"
          :key="s" :style="bg(slide.image)" />
        <!--
        <router-link :to="slide.url" class="slider__slide" v-for="(slide, s) in slides"
          :key="s" :style="bg(slide.image)" />
          -->
      </div>
    </div>
    <i class="slider__nav slider__nav--prev" @click="prev" />
    <i class="slider__nav slider__nav--next" @click="next" />
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'

export default {
  name: 'Slider',
  props: ['slides'],
  data() {
    return {
      slider: {}
    }
  },
  methods: {
    prev() {
      this.slider.slidePrev()
    },
    next() {
      this.slider.slideNext()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.slider = new Swiper(this.$refs['slider'], {
        loop: true,
        wrapperClass: 'slider__wrapper',
        slideClass: 'slider__slide',
        slideActiveClass: 'is-active',
        slideDuplicatedActiveClass: 'is-duplicate',
        slideDuplicateClass: 'is-duplicate',
        slideVisibleClass: 'is-visible',
        slideNextClass: 'is-next',
        slideDuplicatedNextClass: 'is-next',
        slidePrevClass: 'is-prev',
        slideDuplicatedPrevClass: 'is-prev',
        slidesPerView: 4,
        breakpoints: {
          768: {
            slidesPerView: 2
          }
        }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Slider.vue